<template>
  <Card id="applications-card">
    <CardHeader class="flex flex-wrap items-center justify-between">
      <CardTitle>Applications</CardTitle>
    </CardHeader>
    <CardContent>
      <div class="space-y-2">
        <component
          :is="application.v2_job ? 'router-link' : 'div'"
          v-for="application in applications"
          :key="application.id"
          :to="application.v2_job ? `/jobs/${application.v2_job.id}` : undefined"
          :class="[
            'flex items-center gap-3 rounded-lg bg-gray-100 px-3 py-2.5',
            application.v2_job ? 'hover:bg-gray-200/70 transition-colors' : '',
          ]"
        >
          <vue-feather type="briefcase" class="shrink-0 h-4 w-4 text-gray-400" />
          <div class="min-w-0 flex-1">
            <p class="truncate text-sm font-medium text-gray-900">{{ roleTitle(application) }}</p>
            <p v-if="location(application)" class="truncate text-xs text-gray-500">{{ location(application) }}</p>
          </div>
          <span v-if="application.created_at" class="shrink-0 text-xs text-gray-500">
            Applied {{ formatShortDate(application.created_at) }}
          </span>
        </component>
      </div>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatShortDate } from '@/utilities/format';
import type { Application } from './ContactDetail';

defineProps<{ applications: Application[] }>();

const roleTitle = (application: Application): string => application.v2_job?.title ?? 'General application';

const location = (application: Application): string => {
  const jobLocation = application.v2_job?.job_locations?.find(l => l.id === application.job_location_id);
  if (jobLocation?.city && jobLocation?.state) return `${jobLocation.city}, ${jobLocation.state}`;
  return '';
};
</script>
